import React from "react";
import { ArrowUpRight, ArrowDownLeft } from "lucide-react";

const TransactionItem = ({ transaction }) => {
  const isCredit = transaction.amount > 0;

  return (
    <div className="flex items-center p-4 border-b border-slate-100 last:border-b-0">
      <div
        className={`w-10 h-10 rounded-full flex items-center justify-center mr-4 ${
          isCredit
            ? "bg-green-100 text-green-600"
            : "bg-slate-100 text-slate-600"
        }`}
      >
        {isCredit ? <ArrowDownLeft size={20} /> : <ArrowUpRight size={20} />}
      </div>
      <div className="flex-grow">
        <p className="font-medium text-slate-800">{transaction.description}</p>
        <p className="text-sm text-slate-500">{transaction.date}</p>
      </div>
      <div
        className={`font-semibold ${
          isCredit ? "text-green-600" : "text-slate-800"
        }`}
      >
        {isCredit ? "+" : ""}
        {transaction.amount.toLocaleString("en-US", {
          style: "currency",
          currency: "ETB",
          minimumFractionDigits: 2,
        })}
      </div>
    </div>
  );
};

export default TransactionItem;
